import { LanOutlined, PeopleAltOutlined, SmartToyOutlined } from '@mui/icons-material'
import { generatePath } from 'react-router-dom'

import { ROUTES } from 'routes'

import type { SidebarItem } from '../types'
import type { TFunction } from 'i18next'
import type { Ability } from 'providers/casl/types/ability'

export const configAdmin = (t: TFunction<'features/layout'>, ability: Ability): SidebarItem[] => [
  {
    icon: <LanOutlined data-cy='lan-outlined-icon' />,
    title: t('sidebar.employee.workspaces'),
    to: ROUTES.WORKSPACE.LIST,
  },
  {
    hidden: ability.cannot('access', 'UserPage-list'),
    icon: <PeopleAltOutlined data-cy='people-alt-outlined-icon' />,
    selectablePaths: [
      generatePath(ROUTES.USER.LIST, { tab: 'publishers' }),
      generatePath(ROUTES.USER.LIST, { tab: 'employees' }),
    ],
    title: t('sidebar.employee.userManagement'),
    to: generatePath(ROUTES.USER.LIST, { tab: 'publishers' }),
  },
  {
    icon: <SmartToyOutlined data-cy='smart-toy-outlined-icon' />,
    title: t('sidebar.employee.yieldbirdWrapperAgent'),
    to: ROUTES.YIELDBIRD_WRAPPER_AGENT,
  },
]
